<script setup lang="ts">
import {
  PLANNING_DAYS,
  PLANNING_SLOTS,
} from '~/composables/useOfferteWizard'

const {
  planningSlots,
  planningNoPreference,
  fieldErrors,
  togglePlanningSlot,
  setPlanningNoPreference,
} = useOfferteWizard()

function isSelected(day: string, slotId: string) {
  return planningSlots.value.includes(`${day}:${slotId}`)
}
</script>

<template>
  <section class="pa-wizard__panel">
    <div class="pa-wizard__panel-head">
      <h2>Wanneer schikt het je?</h2>
      <p>Op welke dagdelen ben je beschikbaar voor de afspraak? Selecteer alles wat past — hoe meer opties, hoe sneller we een moment vinden.</p>
    </div>

    <p v-if="fieldErrors._planning" class="pa-wizard__error pa-wizard__error--block">
      {{ fieldErrors._planning }}
    </p>

    <div class="pa-wizard__planning">
      <div
          v-for="day in PLANNING_DAYS"
          :key="day"
          class="pa-wizard__planning-row"
      >
        <div class="pa-wizard__planning-day">{{ day }}</div>
        <div class="pa-wizard__planning-slots">
          <button
              v-for="slot in PLANNING_SLOTS"
              :key="slot.id"
              type="button"
              class="pa-wizard__planning-slot"
              :class="{ 'pa-wizard__planning-slot--selected': isSelected(day, slot.id) }"
              :aria-pressed="isSelected(day, slot.id)"
              @click="togglePlanningSlot(day, slot.id)"
          >
            <span class="pa-wizard__planning-check" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </span>
            <span class="pa-wizard__planning-slot-text">
              <span class="pa-wizard__planning-slot-label">{{ slot.label }}</span>
              <span class="pa-wizard__planning-slot-time">{{ slot.time }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>

    <button
        type="button"
        class="pa-wizard__planning-none"
        :class="{ 'pa-wizard__planning-none--selected': planningNoPreference }"
        :aria-pressed="planningNoPreference"
        @click="setPlanningNoPreference(!planningNoPreference)"
    >
      <span class="pa-wizard__planning-none-radio" aria-hidden="true">
        <span v-if="planningNoPreference" class="pa-wizard__planning-none-dot" />
      </span>
      <span class="pa-wizard__planning-none-text">
        <span class="pa-wizard__planning-none-title">Ik heb geen voorkeur</span>
        <span class="pa-wizard__planning-none-sub">Plan gerust de eerst mogelijke afspraak in — wij stemmen het moment met je af.</span>
      </span>
    </button>
  </section>
</template>
